import { Trans } from '@lingui/react'
import { bool, node, string } from 'prop-types'

import { SA_SELLER_ID } from 'shared/consts/checkout'
import Button from 'views/components/atoms/Button'
import Modal from 'views/components/molecules/Modal'
import AddressList from 'views/components/organisms/Checkout/AddressList'

const AddressSelectionModal = ({
  sellerId,
  subOrderId,
  modalId,
  title,
  size,
  open,
}) => {
  return (
    <Modal
      {...{
        id: modalId,
        size,
        title: title || <Trans id="modal.address.title" />,
        open,
      }}
      isClientSideControlled
    >
      <AddressList
        sellerId={sellerId}
        subOrderId={subOrderId}
        allowChanges={false}
      />
      <Button
        style="buttonGhost"
        name="address-selection-modal-close-button"
        data-a11y-dialog-hide
        href="#"
      >
        <Trans id="checkout.address.backWithoutChanges" />
      </Button>
    </Modal>
  )
}

AddressSelectionModal.propTypes = {
  sellerId: string,
  subOrderId: string,
  modalId: string.isRequired,
  size: string.isRequired,
  title: node,
  open: bool,
}

AddressSelectionModal.defaultProps = {
  sellerId: SA_SELLER_ID,
  subOrderId: null,
  title: null,
  open: false,
}

export default AddressSelectionModal
